import {useApi} from "@/lib/hook";

export const useLocale = () => {
    const {data, isFetching} = useApi({
        route: {name: 'core.locales'},
        setting: {
            staleTime: Infinity,
            placeholderData: {
                locales: [],
                locale: 'en',
            }
        }
    })

    return {
        locale: data.locale ?? 'en',
        locales: data.locales ?? [],
        isFetching
    };
}